import React from "react";
import {
    Datagrid,
    List,
    ImageField,
    ImageInput,
    SimpleShowLayout,
    TextField,
    TextInput, DateField, BooleanInput, required, BooleanField, ArrayInput, SimpleFormIterator, SelectInput, ArrayField
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import {Markets} from "../../constants/choices";

export const ForumCategoryList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <ImageField source="icon"/>
      <TextField source="title"/>
      <TextField source="description"/>
      <BooleanField source="isPremium"/>
    </Datagrid>
  </List>
);

export const ForumCategoryEdit = (props) => (
  <EditView {...props}>
    <TextInput source="title" validate={required()}/>
    <TextInput source="description" validate={required()}/>
    <BooleanInput source="isPremium" validate={required()}/>
    <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" title="imageUrl"/>
    </ImageInput>
    <TextInput source="icon" validate={required()}/>
      <ArrayInput source="adminMarkets">
          <SimpleFormIterator>
              <SelectInput source="markets" choices={Markets} />
          </SimpleFormIterator>
      </ArrayInput>
  </EditView>
);

export const ForumCategoryShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="objectId"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <ImageField source="icon"/>
      <TextField source="title"/>
      <TextField source="description"/>
      <BooleanField source="isPremium"/>
        <ArrayField source="adminMarkets">
            <Datagrid>
                <TextField source="markets" />
            </Datagrid>
        </ArrayField>
    </SimpleShowLayout>
  </ShowView>
);

export const ForumCategoryCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()}/>
    <TextInput source="description" multiline={true} validate={required()}/>
    <BooleanInput label="isPremium" defaultValue={false} source="isPremium" validate={required()} />
    <ImageInput source="pictures" validate={required()} label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" title="imageUrl"/>
    </ImageInput>
      <ArrayInput source="adminMarkets">
          <SimpleFormIterator>
              <SelectInput source="markets" choices={Markets} />
          </SimpleFormIterator>
      </ArrayInput>
  </CreateView>
);
